import { KTResponseCustom, KTResponseDNoResult } from '@interfaces/Generic/KTResponse.interface';

export class BEError<T extends KTResponseCustom<KTResponseDNoResult>> extends Error {
  public response: any;
  constructor(message: T) {
    super();
    this.name = 'BEError';
    this.message = message?.d?.Message || 'Unexpected Error';
    this.response = message;
  }
}
